module.exports = function() {
  return new Worker(__webpack_public_path__ + "31fd28b128bec50fd98c.worker.js");
};